import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {StudentSelectModel} from './StudentSelectModel.js';

export class StudentListModel {
	constructor() {
		this.students = [];
		this.added = new signals.Signal();
		this.removed = new signals.Signal();
		this.changed = new signals.Signal();
		this.selectModel = new StudentSelectModel(this);
	}
	load() {
		DojoDeshi.instance().RPC().StudentsForDojo(0)
		.then(
			(res)=>{
				this.setStudents(res[0]);
			})
		.catch(
			(err)=>{
				console.log(err);
				alert('ERR: ' + err.message);
			});
	}
	setStudents(students) {
		for (let s of this.students) {
			this.removed.dispatch(s, this);
		}
		this.students = [];
		for (let s of students) {
			this.students.push(s);
			this.added.dispatch(s, this);
		}
	}
	[Symbol.iterator]() {
		return this.students[Symbol.iterator]();
	}
}